import { EnrollApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { KEY } from './keys';
import { getQueryKeys } from 'queries/query-key';

function useRemove() {
  const queryClient = useQueryClient();
  return useAuthMutation(EnrollApi.remove, {
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
    },
  });
}

export default useRemove;
